import { COMMITTEE_REPORTS } from "../../actions/types";
const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case COMMITTEE_REPORTS:
      return {
        ...state,
        items: action.payload
      };
    default:
      return state;
  }
}
